/**
 * Convert an HTML string into a document fragment containing DOM nodes.
 * @param {string} htmlString - The HTML string to convert.
 * @returns {DocumentFragment} A document fragment containing the parsed DOM nodes.
 */
function stringToHTML(htmlString) {
  // Use DOMParser if supported
  if (isDOMParserSupported) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const fragment = document.createDocumentFragment();

    // Append all child nodes from the parsed document's body to the fragment
    Array.from(doc.body.childNodes).forEach((node) =>
      fragment.appendChild(node)
    );

    return fragment;
  }

  // Fallback to creating a temporary div element
  const container = document.createElement('div');
  container.innerHTML = htmlString;
  const fragment = document.createDocumentFragment();

  // Append all child nodes from the container to the fragment
  Array.from(container.childNodes).forEach((node) =>
    fragment.appendChild(node)
  );

  return fragment;
}

/**
 * Check if the browser supports DOMParser with 'text/html' parsing.
 * @returns {boolean} `true` if supported, otherwise `false`.
 */
function isDOMParserSupported() {
  if (!window.DOMParser) return false;
  const parser = new DOMParser();
  try {
    parser.parseFromString('x', 'text/html');
  } catch (err) {
    return false;
  }
  return true;
}

export { stringToHTML };
